import { render, staticRenderFns } from "./notify.vue?vue&type=template&id=6c42e752&scoped=true"
import script from "./notify.vue?vue&type=script&lang=js"
export * from "./notify.vue?vue&type=script&lang=js"
import style0 from "./notify.vue?vue&type=style&index=0&id=6c42e752&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c42e752",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c42e752')) {
      api.createRecord('6c42e752', component.options)
    } else {
      api.reload('6c42e752', component.options)
    }
    module.hot.accept("./notify.vue?vue&type=template&id=6c42e752&scoped=true", function () {
      api.rerender('6c42e752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/notify.vue"
export default component.exports